import { select, t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { Banner } from 'components/banner/banner';
import { ErrorIconMUI } from 'components/icons/ErrorIconMUI';
import type { PharmacyPanelist } from 'types/api/pharmacies/panelist_connection';
import { PanelistConnectionSteps } from '../PanelistConnectionSteps';

type Props = {
  pharmacyPanelist: PharmacyPanelist;
};

export const ConnectionNotEstablishedBanner = ({ pharmacyPanelist }: Props) =>
  pharmacyPanelist.panelist &&
  (pharmacyPanelist.status === 'sharing_not_approved' ||
    pharmacyPanelist.status === 'not_client') && (
    <Banner
      icon={<ErrorIconMUI fontSize="medium" sx={{ marginRight: 1 }} />}
      title={
        <Stack gap={2}>
          <Typography variant="subtitle2">
            {select(pharmacyPanelist.status, {
              sharing_not_approved: t`L’extracteur nous signale que vous n’avez pas autorisé le partage de vos données de vente avec Faks.`,
              not_client: t`L’extracteur nous signale que vous n’êtes pas client.`,
              other: pharmacyPanelist.status,
            })}
          </Typography>
          <Box>
            <PanelistConnectionSteps
              panelist={pharmacyPanelist.panelist}
              onboardingUrl={pharmacyPanelist.onboarding_url}
            />
            {pharmacyPanelist.panelist === 'offisante' &&
              pharmacyPanelist.status === 'sharing_not_approved' && (
                <Box pt={2}>
                  <Trans>
                    Si ce message persiste durant <strong>plusieurs jours</strong>, merci de
                    contacter Faks
                  </Trans>
                </Box>
              )}
          </Box>
        </Stack>
      }
      color="error"
      sx={{ mt: 2 }}
    />
  );
